import { IsColumnFunc, IsColumnFuncParams } from 'ag-grid-community';
import { Column } from 'components/atoms/grid';

export const editableWhen = (predicate: IsColumnFunc) => (column: Column) => ({
  ...column,
  editable: (params: IsColumnFuncParams) =>
    predicate(params) &&
    (typeof column.editable === 'boolean'
      ? column.editable
      : column.editable(params)),
});
